import { makeStyles } from "@material-ui/core/styles";

const drawerWidth = 332;

export const useStyles = makeStyles((theme) => ({
  content: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
  },
}));
